import { Container, Grid, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ReactNode } from 'react';

interface CommonLayoutProps {
  children: ReactNode;
}

export default function CommonLayout({
  children,
  ...props
}: CommonLayoutProps) {
  const theme = useTheme();
  const useStyles = makeStyles({
    commonLayoutWrap: {
      paddingBottom: 100,
      paddingTop: 80,
      // minHeight: 'calc(100vh - 172px)',
      flexGrow: 1,
    },
    commonLayoutInner: {
      backgroundColor: 'rgba(239, 255, 250, 0.5)',
      padding: '70px 55px',
      maxWidth: 945,
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        padding: '70px 0',
      },
    },
  });

  const classes = useStyles();
  return (
    <div className={classes.commonLayoutWrap} {...props}>
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.commonLayoutInner}>{children}</div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
